import qs from 'qs'

export const getSessionProperty = (
  storageKey,
  queryParameter,
  searchLocation
) => {
  let propertyValue = sessionStorage.getItem(storageKey)
  return propertyValue
    ? propertyValue
    : searchLocation
    ? setSessionProperty(storageKey, queryParameter, searchLocation)
    : propertyValue
}

export const getQueryParameters = searchLocation => {
  return qs.parse(searchLocation, {
    ignoreQueryPrefix: true
  })
}

export const containsQueryParameter = (queryParametersOnSearchLocation, queryParameter, isSearchLocation = false) => {
  let queryParams = queryParametersOnSearchLocation
  let property = queryParameter
  if (isSearchLocation) {
    queryParams = getQueryParameters(queryParametersOnSearchLocation)
    property = getQueryParameter(queryParams, queryParameter)
  }

  return property && queryParams.hasOwnProperty(property)
}

export const containsQueryParameters = (queryParams, property) => {
  return property && queryParams.hasOwnProperty(property)
}

export const getQueryParameter = (queryParams, queryParameter) => {
  return Object.keys(queryParams).find(
    queryParam => queryParam.toLocaleLowerCase() === queryParameter
  )
}

export const setSessionProperty = (
  storageKey,
  queryParameter,
  containingValue
) => {
  let propertyValue = undefined
  if (!queryParameter) {
    propertyValue = containingValue
  } else {
    const queryParams = getQueryParameters(containingValue)
    const property = getQueryParameter(queryParams, queryParameter)
    if (containsQueryParameter(queryParams, property)) {
      propertyValue = queryParams[property]
    }
  }

  if (propertyValue !== undefined) {
    sessionStorage.setItem(storageKey, propertyValue)
  }

  return propertyValue
}

export const removeSessionProperty = (storageKey) => {
  sessionStorage.removeItem(storageKey);
}
